<template>
	<div class="market">
		<div class="market-content">
			<div class="market-title">
				<h2>应用管理</h2>
			</div>
			<div class="market-notice">
				<i class="el-icon-info"></i>
				<span>创建应用过后，选择开通产品，即可获得APPID及密钥</span>
			</div>
			<div class="market-search">
				<el-input v-model="create.app_name" placeholder="请输入应用名称" class="search-input"></el-input>
				<el-select v-model="create.type" placeholder="请选择应用类型" class="search-select"
					@change="handleSelectChange">
					<el-option v-for="item in chooseData" :key="item.type" :label="item.app_name"
						:value="item.type"></el-option>
				</el-select>
				<el-button type="primary" @click="build" class="search-btn">创建应用</el-button>
			</div>

			<div class="table-container">
				<el-table :data="marketData" style="width: 100%" border>
					<el-table-column label="应用名称" min-width="130">
						<template slot-scope="scope">
							<div class="app-info">
								<span class="app-name">{{ scope.row.app_name }}</span>
								<div class="app-id">Apppid:{{ scope.row.appid }}</div>
								<div class="app-secret">
									<span>secret:
										{{ scope.row.secret ? `${scope.row.secret.slice(0, 4)}****${scope.row.secret.slice(-4)}` : '' }}</span>
									<el-button size="mini" type="text" @click="copySecret(scope.row.secret)"
										class="copy-btn">
										复制密钥
									</el-button>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="100">
						<template slot-scope="scope">
							<el-tag
								:type="scope.row.status == 0 ? 'warning' : scope.row.status == 1 ? 'danger' : 'success'"
								size="small">
								{{
                  scope.row.status == 0 ? "待审核" : scope.row.status == 1 ? "停用" : "开通"
                }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="选择开通产品" min-width="150">
						<template slot-scope="scope">
							<el-select v-model="scope.row.selectedProducts" multiple collapse-tags collapse-tags-tooltip
								placeholder="请选择开通产品" @remove-tag="(val) => handleRemoveTag(val, scope.row)"
								style="width: 100%">
								<el-option v-for="item in productOptions || []" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="通知url" min-width="130">
						<template slot-scope="scope">
							<el-input v-model="scope.row.notice_url" placeholder="请输入通知URL" size="small"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="通知服务">
						<template slot-scope="scope">
							<el-radio-group v-model="scope.row.notice_status">
								<el-radio label="1" size="small">启用</el-radio>
								<el-radio label="0" size="small">关闭</el-radio>
							</el-radio-group>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="300">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">
								产品接入
							</el-button>
							<el-button size="mini" type="info" @click="openQiniuModal(scope.row)"
								icon="el-icon-setting">
								七牛配置
							</el-button>
							<!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
								删除
							</el-button> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 七牛云配置弹窗 -->
		<el-dialog title="七牛云存储配置" :visible.sync="qiniuModalVisible" width="650px" :close-on-click-modal="false"
			@close="resetQiniuForm">
			<el-form :model="qiniuForm" :rules="qiniuRules" ref="qiniuFormRef" label-width="120px"
				label-position="right">
				<el-form-item label="应用ID" prop="app_id">
					<el-input v-model="qiniuForm.app_id" disabled placeholder="当前应用ID"></el-input>
				</el-form-item>
				<el-form-item label="Access Key" prop="access_key">
					<el-input v-model="qiniuForm.access_key" placeholder="请输入七牛云Access Key"></el-input>
				</el-form-item>
				<el-form-item label="Secret Key" prop="secret_key">
					<el-input v-model="qiniuForm.secret_key" placeholder="请输入七牛云Secret Key"></el-input>
				</el-form-item>
				<el-form-item label="存储空间名称" prop="bucket_name">
					<el-input v-model="qiniuForm.bucket_name" placeholder="请输入七牛云存储空间名称"></el-input>
				</el-form-item>
				<el-form-item label="绑定域名" prop="qiniu_domain">
					<el-input v-model="qiniuForm.qiniu_domain" placeholder="请输入七牛云空间绑定域名"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="qiniuModalVisible = false">取消</el-button>
				<el-button type="primary" @click="submitQiniuConfig" :loading="qiniuSubmitting">
					提交配置
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chooseData: [{
						app_name: "app",
						type: 1
					},
					{
						app_name: "web",
						type: 2
					},
					{
						app_name: "小程序",
						type: 3
					},
					{
						app_name: "H5",
						type: 4
					},
					{
						app_name: "UniAp",
						type: 5
					},
					{
						app_name: "桌面应用",
						type: 6
					},
					{
						app_name: "其他",
						type: 0
					},
				],
				marketData: [],
				create: {},
				productOptions: [],
				// 七牛云配置相关
				qiniuModalVisible: false,
				qiniuForm: {
					app_id: "",
					access_key: "",
					secret_key: "",
					bucket_name: "",
					qiniu_domain: "",
				},
				qiniuRules: {
					access_key: [{
						required: true,
						message: "请输入Access Key",
						trigger: "blur"
					}],
					secret_key: [{
						required: true,
						message: "请输入Secret Key",
						trigger: "blur"
					}],
					bucket_name: [{
						required: true,
						message: "请输入存储空间名称",
						trigger: "blur"
					}],
					qiniu_domain: [{
						required: true,
						message: "请输入绑定域名",
						trigger: "blur"
					}],
				},
				qiniuSubmitting: false, // 布尔值，控制loading状态
			};
		},

		methods: {
			async getAppList() {
				// 获取应用列表
				try {
					const res = await this.$api.market.getAppList();
					if (res.code == 200) {
						this.marketData = res.data.map((item) => {
							let selectedProducts = [];
							if (item.product_id && typeof item.product_id === 'string') {
								selectedProducts = item.product_id.split(',').map(id => Number(id)).filter(
									id => !isNaN(id));
							}

							return {
								...item,
								notice_status: (item.notice_status || "0").toString(),
								notice_url: item.notice_url || "",
								selectedProducts: selectedProducts,
								productList: item.product || []
							};
						});

						// 补充：把第一个应用的product列表赋值给下拉选项（如果全局productOptions为空）
						if (this.marketData.length > 0 && this.marketData[0].productList.length > 0) {
							this.productOptions = this.marketData[0].productList;
						}

						// console.log("应用市场列表", this.marketData);
					}
				} catch (error) {
					// console.error("获取应用列表失败:", error);
					this.$message.error("获取应用列表失败");
				}
			},
			copySecret(secret) {
			  if (!secret) {
			    this.$message.warning("密钥不存在");
			    return;
			  }
			  const input = document.createElement("input");
			  input.value = secret;
			  document.body.appendChild(input);
			  input.select();
			  input.setSelectionRange(0, 99999); 
			
			  try {
			    document.execCommand("copy");
			    this.$message.success("密钥已复制到剪贴板");
			  } catch (err) {
			    this.$message.error("复制失败，请手动复制");
			  }
			
			  document.body.removeChild(input);
			},

			
			handleSelectChange(value) {
				const selectedItem = this.chooseData.find((item) => item.type === value);
				if (selectedItem) {
					this.create.type = selectedItem.type;
				}
			},

			async build() {
				if (!this.create.app_name) {
					this.$message.warning("请输入应用名称");
					return;
				}
				if (this.create.type === undefined || this.create.type === null) {
					this.$message.warning("请选择应用类型");
					return;
				}
				try {
					const res = await this.$api.market.create(this.create);
					if (res.code === 200) {
						this.$message.success("创建成功");
						this.create = {};
						this.getAppList();
					} else {
						this.$message.error(res.msg || "创建失败");
					}
				} catch (error) {
					// console.error("创建应用失败:", error);
					this.$message.error("创建应用失败");
				}
			},

			async handleEdit(index, row) {
				const selectedProducts = row.selectedProducts || [];
				try {
					const res = await this.$api.market.launchProduct({
						app_id: row.id,
						notice_status: row.notice_status,
						product_id: selectedProducts.join(","),
						notice_url: row.notice_url,
					});
					if (res.code == 200) {
						this.$message.success(res.msg || "接入成功");
					} else {
						this.$message.error(res.msg || "接入失败");
					}
				} catch (error) {
					console.error("接入产品失败:", error);
					this.$message.error("接入产品失败");
				}
			},

			handleDelete(index, row) {
				this.$confirm("确定要删除该应用吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(async () => {
					try {
						const res = await this.$api.market.deleteApp({
							id: row.id
						});
						if (res.code === 200) {
							this.$message.success("删除成功");
							this.marketData.splice(index, 1);
						} else {
							this.$message.error(res.msg || "删除失败");
						}
					} catch (error) {
						// console.error("删除应用失败:", error);
						this.$message.error("删除应用失败");
					}
				});
			},

			handleRemoveTag(removedValue, row) {
				console.log("删除了标签：", removedValue, "应用：", row.app_name);
			},

			async getProductList() {
				// 保留原有逻辑，作为备用
				try {
					const res = await this.$api.market.getProductList();
					if (res.code == 200) {
						this.productOptions = res.data;
					}
				} catch (error) {
					// console.error("获取产品列表失败:", error);
					// 不再弹窗提示，避免重复提示
				}
			},

			// 打开七牛云配置弹窗
			openQiniuModal(row) {
				this.qiniuModalVisible = true;
				// console.log("七牛配置数据：", row.qiniu_conf);
				this.resetQiniuForm();
				// 初始化基础数据
				this.qiniuForm.app_id = row.id || "";

				// 赋值七牛云配置
				if (row.qiniu_conf && typeof row.qiniu_conf === 'object') {
					this.qiniuForm.access_key = row.qiniu_conf.access_key || "";
					this.qiniuForm.secret_key = row.qiniu_conf.secret_key || "";
					this.qiniuForm.bucket_name = row.qiniu_conf.bucket_name || "";
					this.qiniuForm.qiniu_domain = row.qiniu_conf.qiniu_domain || "";
				}

				//异步更新，强制刷新表单
				this.$nextTick(() => {
					if (this.$refs.qiniuFormRef) {
						// 清除表单验证状态，确保数据显示
						this.$refs.qiniuFormRef.clearValidate();
					}
				});
			},

			// 重置七牛云表单
			resetQiniuForm() {
				this.qiniuForm = {
					app_id: "",
					access_key: "",
					secret_key: "",
					bucket_name: "",
					qiniu_domain: "",
				};
				// 清除验证状态
				if (this.$refs.qiniuFormRef) {
					this.$refs.qiniuFormRef.resetFields();
				}
				this.qiniuSubmitting = false;
			},

			// 提交七牛云配置
			async submitQiniuConfig() {
				try {
					await this.$refs.qiniuFormRef.validate();
					this.qiniuSubmitting = true;

					const formData = new FormData();
					Object.keys(this.qiniuForm).forEach(key => {
						formData.append(key, this.qiniuForm[key]);
					});

					const res = await this.$api.market.qiniuSetting(formData);

					if (res.code === 200) {
						this.$message.success("七牛云配置提交成功");
						this.qiniuModalVisible = false;
						this.resetQiniuForm();
						this.getAppList();
					} else {
						this.$message.error(res.msg || "配置提交失败");
					}
				} catch (error) {
					console.error("提交七牛云配置失败:", error);
					this.$message.error("配置提交失败，请重试");
				} finally {
					this.qiniuSubmitting = false;
				}
			},
		},

		created() {
			this.getAppList();
			this.getProductList();
		},
	};
</script>

<style lang="scss" scoped>
	.market {
		padding: 10px;
		background-color: #f1f4fb;
		min-height: 100vh;

		.market-content {
			background-color: #ffffff;
			padding: 20px;
			border-radius: 8px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

			.market-title {
				margin-bottom: 16px;

				h2 {
					margin: 0;
					padding-bottom: 12px;
					border-bottom: 1px solid #edf0f7;
					font-size: 18px;
					font-weight: 600;
					color: #333;
				}
			}

			.market-notice {
				margin: 16px 0;
				padding: 12px 16px;
				background: linear-gradient(135deg, rgba(255, 107, 53, 0.08), rgba(255, 140, 66, 0.05));
				border-radius: 8px;
				border: 1px solid rgba(255, 107, 53, 0.15);
				display: flex;
				align-items: center;
				gap: 10px;

				i {
					color: #ff6b35;
					font-size: 16px;
					flex-shrink: 0;
				}

				span {
					font-size: 13px;
					color: #6a6a8a;
					line-height: 1.5;
				}
			}

			.market-search {
				display: flex;
				gap: 12px;
				align-items: center;
				margin-bottom: 20px;

				.search-input {
					width: 240px;
				}

				.search-select {
					width: 180px;
				}

				.search-btn {
					white-space: nowrap;
				}
			}

			.table-container {
				margin-top: 16px;

				::v-deep .el-table {
					--el-table-header-text-color: #666;
					--el-table-row-hover-bg-color: #f8f9fa;
				}

				::v-deep .app-info {
					display: flex;
					flex-direction: column;
					gap: 4px;

					.app-name {
						font-weight: 500;
						color: #333;
						margin-bottom: 4px;
					}

					.app-id,
					.app-secret {
						font-size: 12px;
						color: #666;
						display: flex;
						align-items: center;
						gap: 6px;
					}

					.copy-btn {
						padding: 0;
						font-size: 11px;
						color: #409eff;
					}
				}
			}
		}
	}

	// 弹窗样式优化
	::v-deep .el-dialog__body {
		padding: 20px;
	}

	::v-deep .el-form-item {
		margin-bottom: 16px;
	}
</style>